import Crud from '../views/ProfessionalType/Crud'
import Entity from '../views/ProfessionalType/Add'

let routes = {
    path: '/professional_types',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/professional_types/add',
            name: 'NewProfessionalType',
            component: Entity,
            meta: {
                pageTitle: 'Tipo de Profissional',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'Adicionar Profissional',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/professional_types/edit/:id?',
            name: 'EditProfessionalType',
            component: Entity,
            meta: {
                pageTitle: 'Tipo de Profissional',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'Editar Tipo de Profissional',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/professional_types',
            name: 'list-professional-types',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Tipos de Profissionais',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'Tipos de Profissionais',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
